import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";
import { TrendConfig, Variable } from "../../shared/analysis";

import { doREQUEST_ERROR, doREQUEST_COMPLETE } from "../state";
import { FetchDuration } from "../../model/dto";
import { getToken } from "./token_fetcher";
import { Dispatch, SetStateAction } from "react";

export const REQUEST_ANALYTIC_GRAPH_TREND_GROUP_MULTIPLE_DURATION_FETCH =
  "REQUEST_ANALYTIC_GRAPH_TREND_GROUP_MULTIPLE_DURATION_FETCH";
export const doREQUEST_ANALYTIC_GRAPH_TREND_GROUP_MULTIPLE_DURATION_FETCH = createDoRequestAction(
  REQUEST_ANALYTIC_GRAPH_TREND_GROUP_MULTIPLE_DURATION_FETCH,
);

export const requestAnalyticGraphTrendGroupMultipleDurationFetchActionCreators = {
  doREQUEST_ANALYTIC_GRAPH_TREND_GROUP_MULTIPLE_DURATION_FETCH,
};

export function* requestAnalyticGraphTrendGroupMultipleDurationFetch({
  payload,
  type,
  setRequestResult,
}: {
  payload: {
    requestId: string;
    participantIds: string[];
    yymmddDurations: Record<string, FetchDuration>;
    variables: Variable[];
    config?: TrendConfig;
  };
  type: string;
  setRequestResult: Dispatch<SetStateAction<RequestResult | null>>;
}): SagaIterator {
  debug("saga*requestAnalyticGraphTrendGroupMultipleDurationFetch");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        participantIds: v.array().min(3).items(v.string().uuid().required()),
        yymmddDurations: v
          .object<Record<string, FetchDuration>>()
          .pattern(
            v.string(),
            v.object({
              yymmddIndexStart: v.number().integer().positive().required(),
              yymmddIndexEnd: v.number().integer().positive().required(),
            }),
          )
          .min(2)
          .required(),
        variables: v
          .array()
          .min(2)
          .max(4)
          .items(
            v
              .object({
                identifier: v.string().exist(),
              })
              .unknown(true)
              .required(),
          )
          .required(),
        config: v
          .object({
            color_discreate_sequence: v.array().items(v.string()).optional(),
          })
          .optional(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_ANALYTIC_GRAPH_TREND_GROUP_MULTIPLE_DURATION_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { participantIds, yymmddDurations, variables, config } = payload;
  const accessToken = yield call(getToken);
  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/analytic-graph-trend-group-multiple-duration-fetch`,
    accessToken,
    data: {
      participantIds,
      yymmddDurations,
      variables,
      config,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_ANALYTIC_GRAPH_TREND_GROUP_MULTIPLE_DURATION_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/analytic-graph-trend-group-multiple-duration-fetch",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_ANALYTIC_GRAPH_TREND_GROUP_MULTIPLE_DURATION_FETCH,
        fromPayload: payload,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* analyticGraphTrendGroupMultipleDurationFetchSaga() {
  yield takeEvery(
    REQUEST_ANALYTIC_GRAPH_TREND_GROUP_MULTIPLE_DURATION_FETCH,
    requestAnalyticGraphTrendGroupMultipleDurationFetch,
  );
}
